import { GetServerSideProps } from 'next'

import { StoryDetailPage } from '@features/myWriting/pages/StoryDetailPage'
import { StoryProvider } from '@hooks/book/useStory'
import { withAuthenGuard } from '@lib/hoc/withAuthenGuard'
import { AppLayout } from '@components/layouts/AppLayout'
import { maintenanceHandler } from '@lib/maintenanceHandler'

interface StoryDetailProps {
  bookId: number
}

function StoryDetail({ bookId }: StoryDetailProps) {
  return (
    <AppLayout>
      <StoryProvider bookId={bookId}>
        <StoryDetailPage />
      </StoryProvider>
    </AppLayout>
  )
}

export const getServerSideProps: GetServerSideProps = async ({ params }) => {
  const bookId = Number(params?.id)

  return maintenanceHandler({
    key: `my-writing-${bookId}`,
    bookId,
  })
}

export default withAuthenGuard(StoryDetail)
